import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'theme',
  initialState: { darkmode: (localStorage.theme && localStorage.theme=='dark' ? true : false ) },
  reducers: {
    updateThemeDarkmode: (state, action) => {
      state.darkmode = action;
    },
  },
});

export const { updateThemeDarkmode } = themeSlice.actions;

export default themeSlice.reducer;